/**
 * Phrase montrée à l'avocat quand une suppression a réussi en base mais que des
 * fichiers sont restés dans le stockage (`filesFailed` des routes de suppression).
 */
export function orphanedFilesNotice(count: number): string {
  const many = count > 1;
  return `${count} fichier${many ? 's' : ''} n'${many ? 'ont' : 'a'} pas pu être effacé${many ? 's' : ''} du stockage. Signalez-le au support si le message revient.`;
}
